import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { Session } from "@/utils/types/flavor";

type SessionStore = {
  session: Session | null;
  starred: boolean;
  setSession: (s: Session | null) => void;
  patchSession: (p: Partial<Session>) => void;
  toggleStarred: () => void;
};

export const useSessionStore = create<SessionStore>()(
  persist(
    (set) => ({
      session: null,
      starred: false,
      setSession: (s) => set({ session: s, starred: !!s?.starred }),
      patchSession: (p) =>
        set((state) =>
          state.session ? { session: { ...state.session, ...p } } : state
        ),
      toggleStarred: () => set((state) => ({ starred: !state.starred })),
    }),
    {
      name: "palate_session",
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ session: s.session, starred: s.starred }),
    }
  )
);
